// Full Force Car Premium - Site-wide constants
export const SITE = {
  name: "Full Force Car Premium",
  tagline: "Câmbio Automático e Mecânica em Geral",
  city: "Jundiaí/SP",
  phone: "(11) 99895-7878",
  phoneRaw: "5511998957878",
  instagram: "@fullforce_car_premium",
  instagramUrl: "https://instagram.com/fullforce_car_premium",
  address: "R. José Artur Savieto, 210 - Cidade Nova, Jundiaí - SP, 13219-510",
  addressShort: "R. José Artur Savieto, 210 — Cidade Nova",
  hours: {
    weekdays: "Segunda a sexta — 08:00 às 18:00",
    saturday: "Sábado — Consultar disponibilidade",
    sunday: "Domingo — Fechado",
  },
  rating: { stars: 5.0, count: 3 },
  logo: "https://customer-assets.emergentagent.com/job_0fda9f05-e106-48b1-a73a-a5254fa8ed2a/artifacts/nlflp2vy_SEM%20FUNDO.png",
};

export const WHATSAPP_MSG = encodeURIComponent(
  "Olá, vim pelo site da Full Force Car Premium e gostaria de agendar uma avaliação para meu veículo."
);

export const WHATSAPP_URL = `https://wa.me/${SITE.phoneRaw}?text=${WHATSAPP_MSG}`;

export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=R.+Jos%C3%A9+Artur+Savieto%2C+210+-+Cidade+Nova%2C+Jundia%C3%AD+-+SP%2C+13219-510";

export const MAPS_EMBED =
  "https://www.google.com/maps?q=R.+Jos%C3%A9+Artur+Savieto%2C+210+-+Cidade+Nova%2C+Jundia%C3%AD+-+SP%2C+13219-510&output=embed";
